import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

/**
 * Compteur « comptes GAR en attente d'import » (spec GAR §10, back Train 2 bloc 4).
 * GET /eleves-gar/en-attente/?etablissement_id=X →
 *   { count, dernier_import_le, comptes: [{id_gar, nom, prenom, classe_nom}] }
 * Filtré côté back sur le PÉRIMÈTRE importé (classes ayant des fiches actives) :
 * un élève d'une classe hors licence ne fait pas crier le compteur.
 * Ne s'active que pour un établissement GAR (les EleveGar n'existent qu'en GAR).
 */
export const useComptesGarEnAttente = (etablissementId, isGar, refresh) =>
    useApi(
        `${url}eleves-gar/en-attente/?etablissement_id=${etablissementId}`,
        { count: 0, dernier_import_le: null, comptes: [] },
        refresh,
        etablissementId && isGar ? undefined : 'not-enabled',
    );
